var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliveryfound
    ? _c("div", { staticClass: "alert alert-danger" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$translate("Klettershop5::Template.deliverySubText")) +
            "\n"
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }